"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactContentLoader = _interopRequireDefault(require("react-content-loader"));
var _hooks = require("./hooks");
const contentLoaderStyle = {
  paddingLeft: 15,
  paddingRight: 15,
  marginRight: 10,
  marginTop: 7,
  marginBottom: 3
};
const Loading = () => {
  var _React$useContext;
  const filters = (_React$useContext = _react.default.useContext(_hooks.FacetsContext)) === null || _React$useContext === void 0 ? void 0 : _React$useContext.filters;
  const getLoader = (width, filter) => /*#__PURE__*/_react.default.createElement(_reactContentLoader.default, {
    key: filter,
    height: 20,
    viewBox: `0 0 ${width} 20`,
    style: contentLoaderStyle
  }, /*#__PURE__*/_react.default.createElement("rect", {
    x: 0,
    y: 0,
    rx: 3,
    ry: 3,
    width: width,
    height: 20
  }));
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, filters.map(filter => {
    if (filter === 'tags') {
      return getLoader(70, filter);
    }
    if (filter === 'categories') {
      return getLoader(85, filter);
    }
    if (filter === 'types') {
      return getLoader(60, filter);
    }
    if (filter === 'statuses') {
      return getLoader(120, filter);
    }
    return getLoader(110, filter);
  }));
};
var _default = exports.default = Loading;
//# sourceMappingURL=Loading.js.map